import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../../../../../../../../commons/formik/FormikActions";
import FormikDatePicker from "../../../../../../../../../commons/formik/FormikDatePicker";
import FormikTextField from "../../../../../../../../../commons/formik/FormikTextField";
import { StyledResolucion } from "../../../../../../../../../styled/Prevencion";
import { validateResponsableUsoForm } from "../../../../../formValidations";

const ResponsableUsoForm = ({ open, handleClose, handleSubmit, values }) => {
    return (
        <Dialog open={open} fullWidth maxWidth="sm">
            <DialogTitle>Administrar Responsable de Uso</DialogTitle>
            <Formik
                initialValues={values}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validateResponsableUsoForm}
            >
                {() => (
                    <Form>
                        <DialogContent>
                            <Grid container >
                                {/* Cuil del Responsable */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="cuitResponsable"
                                        label="CUIL del Responsable *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Nro. Autorización Individual */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="numeroAutorizacionIndividual"
                                        label="Nro. Autorización Individual *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Nro. Permiso Habilitante */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="numeroPermisoHabilitante"
                                        label="Nro. Permiso Habilitante *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Matrícula Profesional */}
                                <StyledResolucion.DialogGridItem item xs={12}>
                                    <FormikTextField
                                        name="matriculaProfesional"
                                        label="Título - Nro. de matrícula y entidad otorgante *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Fecha de Expedición */}
                                <StyledResolucion.DialogGridItem item xs={6}>
                                    <FormikDatePicker
                                        name="fechaExpedicion"
                                        label="Fecha de Expedición *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>

                                {/* Fecha de Vencimiento */}
                                <StyledResolucion.DialogGridItem item xs={6}>
                                    <FormikDatePicker
                                        name="fechaVencimiento"
                                        label="Fecha de Vencimiento *"
                                        fullWidth
                                    />
                                </StyledResolucion.DialogGridItem>
                            </Grid>
                        </DialogContent>

                        <DialogActions>
                            <FormikActions handleCancel={handleClose} />
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default ResponsableUsoForm;
